/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeterFrameUnitType = {
    NotSpecified: 'NotSpecified',
    ChargingStation: 'ChargingStation',
    HeatPump: 'HeatPump',
    BatterySystem: 'BatterySystem',
    SolarPowerSystem: 'SolarPowerSystem',
    WindTurbine: 'WindTurbine',
    WaterTurbine: 'WaterTurbine',
    GasTurbine: 'GasTurbine',
} as const;
export type MeterFrameUnitType = typeof MeterFrameUnitType[keyof typeof MeterFrameUnitType];

